import { render, staticRenderFns } from "./locationsTable.vue?vue&type=template&id=716b13b2&"
import script from "./locationsTable.vue?vue&type=script&lang=js&"
export * from "./locationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports